import React, { Component } from "react";
import "./spinner.scss";

export default class Spinner extends Component {
  render() {
    return (
      <div id="spinner" className="spinner-container">
        <div className="spinner">
          <div className="lds-hourglass"></div>
        </div>
      </div>
    );
  }
}
